export const GEO_POLICY = {
  enableHighAccuracy: true,
  timeout: 15000,
  maximumAge: 0,
  maxAccuracyMeters: 100,
  retries: 1,
};

const readOnce = (options) =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });

export async function getBrowserPosition() {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    const error = new Error('Este navegador não oferece geolocalização.');
    error.code = 'unsupported';
    throw error;
  }

  if (typeof window !== 'undefined' && window.isSecureContext === false) {
    const error = new Error('A localização do navegador exige HTTPS ou localhost.');
    error.code = 'insecure';
    throw error;
  }

  const options = {
    enableHighAccuracy: GEO_POLICY.enableHighAccuracy,
    timeout: GEO_POLICY.timeout,
    maximumAge: GEO_POLICY.maximumAge,
  };

  let position = null;
  for (let attempt = 0; attempt <= GEO_POLICY.retries; attempt += 1) {
    position = await readOnce(options);
    const accuracy = position.coords.accuracy;
    if (accuracy != null && accuracy > 0 && accuracy <= GEO_POLICY.maxAccuracyMeters) {
      break;
    }
  }

  return {
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
    accuracy: position.coords.accuracy,
    captured_at: new Date(position.timestamp || Date.now()).toISOString(),
  };
}

export function describeGeolocationError(error) {
  if (!error) return 'Erro ao obter localização.';
  if (error.code === 'unsupported' || error.code === 'insecure') return error.message;
  if (error.code === 1) {
    return 'Permissão de localização negada. Ative a localização para registrar o ponto.';
  }
  if (error.code === 2) {
    return 'Localização desativada ou indisponível. Ative o GPS e tente novamente.';
  }
  if (error.code === 3) {
    return 'Tempo esgotado ao obter a localização. Tente novamente em um local com melhor sinal.';
  }
  return error.message || 'Erro ao obter localização.';
}
